import { render, staticRenderFns } from "./LoginDialog.vue?vue&type=template&id=0907b1aa&scoped=true"
import script from "./LoginDialog.vue?vue&type=script&lang=js"
export * from "./LoginDialog.vue?vue&type=script&lang=js"
import style0 from "./LoginDialog.vue?vue&type=style&index=0&id=0907b1aa&prod&scoped=true&lang=less"
import style1 from "./LoginDialog.vue?vue&type=style&index=1&id=0907b1aa&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0907b1aa",
  null
  
)

export default component.exports